import React from 'react'
import {BsArrowRightSquare} from 'react-icons/bs'
import {Link} from 'react-scroll'

const Home = () => {
  return (
    <div 
    name="home"
     className="h-screen w-full bg-gradient-to-b from-black via-black to-gray-800">
      <div className="max-w-screen-lg mx-auto flex flex-col
      items-left justify-left h-full px-4 md:flex-row">
        <div className="flex flex-col justify-center h-full">
            <h2 className="text-4xl sm:text-7xl font-bold text-white">I am a Web Developer</h2>
            <p className="text-gray-400 py-4 max-w-md">I am a passionate web developer.
                I use React.js, Tailwind and Javscript and I have experience with SQL, Python,
                and Adobe Photoshop.
                </p>
                <div>
                    <Link to="portfolio"
                     smooth duration={500}
                     className="group text-white w-fit px-6 py-3 my-2
                    flex items-center rounded-md bg-gradient-to-r
                    from-cyan-600 to-blue-700 ">
                        Portfolio 
                        <span className="group-hover:rotate-90 duration-300 ml-2">

                            <BsArrowRightSquare size={20}/>
                        </span>
                    </Link>
                </div>
        </div>
      </div>
    </div>
  )
}

export default Home
